<template>
  <div class="differentials w-100 position-relative px-3">
    <b-container class="shadow-sm">
      <b-row>
        <b-col
          class="pt-1 pb-3 d-flex flex-column text-center align-items-center"
          v-for="dif in differentials"
          :key="dif.id"
          :class="dif.bg"
          :lg="dif.col.lg"
          :md="dif.col.md"
        >
          <img class="px-3" :src="require(`@/assets/icons/${dif.icon}`)" width="120" />
          <h5 class="text-uppercase text-purple" v-html="dif.title" />
          <p
            class="text-purple font-weight-light"
            style="margin-bottom: 0px; font-size: 90%;"
            v-html="dif.text"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      differentials: [
        {
          icon: "icon-money.svg",
          title: "Dinheiro na mesma hora",
          text:
            "Você entrega as chaves <b>só depois de receber</b> a transferência bancária",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-yellow",
        },
        {
          icon: "icon-deal.svg",
          title: "Melhor oferta do Brasil",
          text:
            "Temos mais de 15.000 compradores prontos para fazer a melhor oferta em seu veículo em minutos",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-orange",
        },
        {
          icon: "icon-padlock.svg",
          title: "Totalmente Seguro",
          text:
            "Receba todos os <b>comprovantes de quitação</b> antes de entregar as chaves do seu carro",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-yellow",
        },
        {
          icon: "icon-chronometer.svg",
          title: "Venda Rápida",
          text:
            "Sem aquela enrolação de trocas, sites de anuncio ou financiamento furado. <b>Proposta aceita é dinheiro na hora</b>",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-orange",
        },
        {
          icon: "icon-car-price.svg",
          title: "Carros com débitos",
          text:
            "Se seu carro tem débitos, multas ou financiamento, <b>nós quitamos tudo pra você</b>",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-yellow",
        },
        {
          icon: "icon-search-car.svg",
          title: "A melhor avaliação do seu veículo",
          text:
            "Seu carro recebe a melhor avaliação dentro do <b>valor de mercado</b>",
          col: {
            md: "4",
            lg: "2",
          },
          bg: "bg-orange",
        },
      ],
    };
  },
};
</script>

<style scoped>
.differentials {
  top: -75px;
}

.text-grey-80 {
  color: rgba(0, 0, 0, 0.67);
}
</style>
